import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

type PostServicesRequest = {
    mainServices: string[];
    additionalServices: {
        id: string;
        options: number[];
    }[];
}

export const servicesService = {
    services: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.services);
    },
    addServices: async (data: PostServicesRequest): Promise<IApiServiceResponse> => {
        const request = new basicRequest(true, 60000);
        return await request.post(apiUrls.postServices, data);
    },
    serviceInfo: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.servicesInfo);
    },
}